import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import InstallAppButton from "@/components/InstallAppButton";

/**
 * Floating bottom banner — encourages mobile users to install PWA.
 * Auto-shows on mobile after 30s. Dismissable for 7 days.
 * Hidden on /community (chat send button would be overlapped).
 */
const STORAGE_KEY = "tigik_install_banner_hidden_until";

export default function MobileInstallBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Hide on chat pages (would overlap input/send button)
    if (window.location.pathname.startsWith("/community")) return;
    // Skip if already installed (PWA standalone)
    if (window.matchMedia?.("(display-mode: standalone)").matches) return;
    if (window.navigator.standalone) return; // iOS PWA flag

    const hiddenUntil = localStorage.getItem(STORAGE_KEY);
    if (hiddenUntil && Date.now() < parseInt(hiddenUntil, 10)) return;

    if (window.innerWidth > 900) return;

    const t = setTimeout(() => setShow(true), 30000);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    setShow(false);
    localStorage.setItem(STORAGE_KEY, String(Date.now() + 7 * 24 * 3600 * 1000));
  };

  if (!show) return null;

  return (
    <div
      data-testid="mobile-install-banner"
      className="fixed bottom-3 left-3 right-3 z-50 flex items-center gap-3 px-4 py-3 border border-gold-700/60 bg-zinc-950/95 backdrop-blur-md shadow-[0_8px_30px_-10px_rgba(212,175,55,0.6)]"
    >
      <div className="w-9 h-9 flex items-center justify-center bg-gold-500/15 border border-gold-700">
        <Download className="w-4 h-4 text-gold-400" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-display font-bold text-sm">Stiahnuť Tigik do mobilu</div>
        <div className="text-[11px] text-zinc-400 font-mono uppercase tracking-wider truncate">Notifikácie aj keď je app zatvorená</div>
      </div>
      <InstallAppButton className="!px-3 !py-2" />
      <button onClick={dismiss} data-testid="mobile-install-dismiss" aria-label="Zavrieť"
        className="text-zinc-500 hover:text-white p-1">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
